<template>
  <div class="Footer-container">
      <div class="Footer-Box">
        <span class="CopyRight-Sign">{{copysign}}<span class="CopyRight-Text">{{getCopyRights}}</span></span>
      </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  data () {
    return {
      copysign: '© '
    }
  },
  computed: {
    getCopyRights: function () {
      return 'Copyright ' + new Date().getFullYear() + ' Dove Technologies Limited All Rights Reserved'
    }
  }
}
</script>
<style scoped>
.Footer-container {
  height: 40px;
  background-color: #395693;
}
.Footer-Box {
  color: white;
  line-height: 40px;
  text-align:left;
}
.CopyRight-Sign {
  margin-left: 15px;
  font-size:15px;
}
.CopyRight-Text {
    font-size:12px;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue